module.exports = __webpack_public_path__ + "img/hdfc-bank.3d31de11.png";